module.exports = __webpack_public_path__ + "media/images/icon-6936d4bc4cddcb64bd739ecc23205364.png";